import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { stopClarity } from '../services/clarity';

const SENSITIVE_PATHS = ['/auth', '/profile', '/client-profile'];

export default function ClarityPrivacyGuard() {
  const { pathname } = useLocation();

  useEffect(() => {
    const isSensitive = SENSITIVE_PATHS.some(
      p => pathname === p || pathname.startsWith(p + '/')
    );
    if (isSensitive) stopClarity();
  }, [pathname]);

  return null;
}
